import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { splayParams } from "../utils/splay-params";

@Injectable()
export class InstructionsService {
  constructor(private http: HttpClient) {}

  public get(params: any) {
    let projectId;
    [params, projectId] = splayParams(params, "projectId");
    const url = `/api/v4/projects/${projectId}/setup-instructions`;
    return this.http.get(url, { params });
  }
}
